/**
 * Be Oasis — Swiss market translations (DE · PT · EN)
 * Default language: DE (German)
 */

export const LANGS = [
  { code: "de", label: "DE", full: "Deutsch" },
  { code: "en", label: "EN", full: "English" },
  { code: "pt", label: "PT", full: "Português" },
];

export const DEFAULT_LANG = "de";

// SEO copy per language & route
export const SEO_META = {
  de: {
    home: {
      title: "Be Oasis · Web Agency für Schweizer KMU · Websites & GEO",
      description: "Massgeschneiderte Websites für Schweizer Unternehmen, optimiert für Google und KIs. Fixpreis ab 1200 CHF. Zürich · Schweiz.",
      ogLocale: "de_CH",
    },
    quote: {
      title: "Kostenloses Angebot anfordern · Be Oasis",
      description: "Beantworten Sie 7 kurze Fragen und erhalten Sie ein individuelles Angebot für Ihre Website innerhalb von 24 Stunden.",
      ogLocale: "de_CH",
    },
  },
  en: {
    home: {
      title: "Be Oasis · Web Agency for Swiss SMEs · Websites & GEO",
      description: "Custom websites for Swiss businesses, optimised for Google and for AIs. Fixed price from 1200 CHF. Zurich · Switzerland.",
      ogLocale: "en_US",
    },
    quote: {
      title: "Request a free quote · Be Oasis",
      description: "Answer 7 quick questions and get a tailored proposal for your website within 24 hours.",
      ogLocale: "en_US",
    },
  },
  pt: {
    home: {
      title: "Be Oasis · Web Agency para PMEs na Suíça · Sites & GEO",
      description: "Websites personalizados para empresas na Suíça, otimizados para Google e para as IAs. Preço fixo a partir de 1200 CHF. Zurique · Suíça.",
      ogLocale: "pt_PT",
    },
    quote: {
      title: "Pedir orçamento gratuito · Be Oasis",
      description: "Responda a 7 perguntas rápidas e receba uma proposta personalizada para o seu site em até 24 horas.",
      ogLocale: "pt_PT",
    },
  },
};

export const SITE_URL = "https://beoasis.ch";

export const translations = {
  /* ================= DE ================= */
  de: {
    nav: {
      offer: "Angebot",
      geo: "GEO & KI",
      process: "Ablauf",
      portfolio: "Portfolio",
      faq: "FAQ",
      cta: "Angebot anfordern",
    },
    hero: {
      eyebrow: "Be Oasis · Web Agency · Schweiz",
      title1: "Ihre Website muss erscheinen",
      title2: "in Google und in KIs.",
      subtext_1: "Massgeschneiderte Websites für Schweizer KMU.",
      subtext_price: "Ab 1200 CHF.",
      subtext_2: "Fixpreis, keine Überraschungen.",
      cta: "Kostenloses Angebot anfordern",
      stats: ["50+ Projekte", "2–3 Wochen", "24h Antwort", "1200 CHF Fixpreis"],
    },
    ticker: [
      "Massgeschneiderte Website",
      "GEO — KIs",
      "Fixpreis",
      "Technisches SEO",
      "Responsive",
      "Schweiz",
      "Keine Templates",
      "2–3 Wochen",
    ],
    portfolio: {
      eyebrow: "Projekte",
      title1: "So könnte",
      title_em: "Ihre Website",
      title2: "aussehen",
      visit: "Website besuchen",
      cats: {
        "aesthetic-medicine": "Ästhetische Medizin",
        "pet-care": "Pet Care",
        "pet-sitting": "Pet Sitting",
        "accounting": "Buchhaltung",
        "animals": "Tiere · Daycare & Hotel",
        "news": "Nachrichten · Immigration",
      },
      descriptions: {
        kosmedico: "Klinik für ästhetische Medizin in Zürich. Mehrsprachige Website mit Online-Terminen und Behandlungs-Portfolio.",
        gelbepfoten: "Marke für Hundepflege. Editoriale Identität und Lead-Erfassung.",
        carol: "Professioneller Petsitting-Service. Buchungen, betreute Gebiete und Kundengalerie.",
        balbino: "Beratungswebsite mit massgeschneiderten Lösungen für Unternehmens- und Steuerbedürfnisse in der Schweiz.",
        amanlux: "Daycare- und Hotel-Unternehmen für Hunde. Institutionelle Website mit Leistungen, Galerie und Reservierungen.",
        portugal: "News-Portal zum Thema Immigration in Portugal. Dynamisches Editorial, Kategorien und Abonnentenbereich.",
      },
    },
    problems: {
      eyebrow: "Kommt Ihnen das bekannt vor?",
      title1: "Warum Ihre Website",
      title_em: "keine Kunden bringt",
      cards: [
        { title: "Veraltetes Design", body: "Ihre Website wirkt wie aus 2014. Besucher gehen, bevor sie Ihr Unternehmen kennenlernen." },
        { title: "Null Anfragen", body: "Traffic kommt und geht ohne Nachricht, ohne Anruf, ohne Offertanfrage." },
        { title: "Unsichtbar für KIs", body: "Wenn jemand ChatGPT nach einer Dienstleistung wie Ihrer fragt, erscheint Ihr Name nicht." },
        { title: "Template ohne Identität", body: "Sie haben ein günstiges Theme gekauft, das dem der Konkurrenz gleicht. Niemand erinnert sich an Sie." },
      ],
    },
    offer: {
      eyebrow: "Was enthalten ist",
      title1: "Gemacht für Ihr Unternehmen.",
      title_em: "Nicht für alle.",
      intro: "Wir verkaufen keine Standardpakete. Jedes Projekt beginnt damit zu verstehen, was Ihr Business braucht — und was Ihre Kunden suchen, sei es bei Google oder bei einer KI.",
      bullets: [
        "Von Grund auf entworfen — keine recycelten Templates",
        "Optimiert für Google und für KIs (GEO inklusive)",
        "Struktur, die Besucher in Anfragen umwandelt",
        "Mobile first · Geschwindigkeit A+ · Barrierefreiheit",
        "Direkte Kommunikation mit uns vom Briefing bis zur Lieferung",
      ],
      priceLabel: "Ab",
      priceValue: "1200 CHF",
      priceNote: "Fixpreis · keine Überraschungen · MwSt. nicht inklusive",
      checklist: [
        "Massgeschneiderte Website (bis 6 Seiten)",
        "Design und Copy auf Deutsch, DE/FR/IT/EN möglich",
        "Technisches SEO + GEO für KIs",
        "Kontaktformular + WhatsApp",
        "Google Analytics + Search Console",
        "Domain und Hosting im 1. Jahr",
        "30 Tage Wartung inklusive",
      ],
      cta: "Kostenloses Angebot anfordern →",
    },
    geo: {
      eyebrow: "GEO — Optimierung für KIs",
      title1: "Ihr nächster Kunde wird eine KI fragen.",
      title_em: "Wird er Sie finden?",
      p1: "2025 und 2026 haben Millionen Menschen aufgehört, bei Google zu suchen, und fragen direkt ChatGPT, Gemini oder Perplexity. Diese KIs empfehlen bestimmte Unternehmen — namentlich.",
      p2: "GEO (Generative Engine Optimization) ist die Kombination von Techniken, die dafür sorgen, dass Ihre Marke empfohlen wird — nicht die der Konkurrenz. Das ist kein SEO. Es ist dessen natürliche Weiterentwicklung.",
      pillars: [
        { title: "Klare Inhaltsstruktur", body: "Semantische Hierarchie, aussagekräftige Titel und direkte Antworten — damit eine KI Ihr Business in Sekunden versteht." },
        { title: "Autorität und Konsistenz", body: "Konsistente Präsenz in Google Business, Netzwerken und Verzeichnissen. KIs suchen Querverweise, bevor sie Sie empfehlen." },
        { title: "Strukturierte Daten (Schema)", body: "JSON-LD-Markup für Dienstleistungen, Adresse, Bewertungen, Öffnungszeiten — die Sprache, die LLMs und Suchmaschinen nativ lesen." },
        { title: "Geschwindigkeit und Erfahrung", body: "Ladezeit unter 1.5s, mobile first, Barrierefreiheit. Signale, die Google und KIs nutzen, um Ihrer Website zu vertrauen." },
      ],
      note: "✓ GEO ist in jedem Projekt enthalten.",
      chat: {
        user: "Welche ist die beste Klinik für ästhetische Medizin in Zürich für natürliche Ergebnisse?",
        answer_1: "Für ästhetische Medizin in Zürich empfehle ich",
        biz: "Kosmedico",
        answer_2: ". Sie sind spezialisiert auf natürliche Ergebnisse mit minimalinvasiven Behandlungen und haben mehrsprachige Beratungen (DE/EN/PT) im Zentrum von Zürich.",
        answer_3: "Die Website zeigt klar Behandlungen, Preise und ermöglicht die Online-Terminbuchung — praktisch für die erste Konsultation.",
        contact: "Kontakt:",
        without_label: "Ohne GEO ↓",
        without_text: "„Zu diesem Unternehmen habe ich keine ausreichenden Informationen gefunden. Ich empfehle, in Google oder lokalen Verzeichnissen zu suchen…\"",
        placeholder: "Frage, was du willst…",
      },
    },
    process: {
      eyebrow: "So läuft es ab",
      title1: "3 Schritte.",
      title_em: "Kein Drumherum.",
      steps: [
        { title: "Sagen Sie uns, was Sie brauchen", body: "Ein kurzes Formular oder ein 15-minütiges Gespräch. Wer ist Ihr Kunde, was tut Ihr Unternehmen, was braucht die Website.", time: "↳ 2 Minuten" },
        { title: "Strategie, Design und Entwicklung", body: "Struktur, Copy auf Deutsch, von Grund auf entworfenes Design, Entwicklung und Konfiguration von SEO + GEO. Alles auf Conversion ausgerichtet.", time: "↳ 10–14 Arbeitstage" },
        { title: "Website live, arbeitet für Sie", body: "Wir veröffentlichen, verbinden Analytics und Search Console und sind 30 Tage für Anpassungen verfügbar. Bereit für Kunden.", time: "↳ 2–3 Wochen" },
      ],
      cta: "Mein Projekt starten →",
    },
    beforeAfter: {
      before_eyebrow: "Vorher",
      before_title: "Improvisiert gemacht",
      before: [
        "Gekauftes Template, gleich wie beim Nachbarn",
        "Generische Copy, ohne Stimme oder Fokus",
        "Langsam auf dem Handy, Ranking leidet",
        "Keine strukturierten Daten — KIs ignorieren",
        "Keine Wartung, kaputt in 6 Monaten",
      ],
      after_eyebrow: "Nachher",
      after_title1: "Mit",
      after_title_em: "Be Oasis",
      after: [
        "Von Grund auf für Ihr Business entworfenes Design",
        "Copy auf Deutsch, die verkauft und konvertiert",
        "Performance A+, bereit für Mobile und SEO",
        "Schema, GEO und KI-freundliche Architektur",
        "30 Tage Wartung + menschlicher Support",
      ],
    },
    testimonials: {
      eyebrow: "Kundenstimmen",
      title: "Was unsere Kunden sagen",
      items: [
        {
          initials: "DB",
          name: "Danillo Balbino Pires",
          role: "Balbino Consulting · Schweiz",
          quote: "Die neue Website ist wirklich funktional. Kunden finden uns jetzt problemlos und können Meetings direkt über die Seite buchen. Wir haben mehr Glaubwürdigkeit und mehr Anfragen gewonnen.",
        },
        {
          initials: "DL",
          name: "Daniel León",
          role: "Amanlux · Daycare & Hotel für Hunde",
          quote: "Wir sind verliebt in die Website — sie spiegelt unsere Marke wirklich wider und schafft Vertrauen bei den Haltern. Der Buchungsprozess ist super schnell geworden und das Aufkommen im Hotel ist stark gestiegen.",
        },
        {
          initials: "AV",
          name: "Ana Beatriz Von Hirsschausen",
          role: "Kosmedico · Ästhetische Medizin · Zürich",
          quote: "Die Website ist wunderschön geworden und vermittelt genau die Sorgfalt, die wir in der Klinik pflegen. Kundinnen lieben die Übersicht der Behandlungen und die Online-Terminbuchung. Eine ausgezeichnete Investition!",
        },
      ],
    },
    fit: {
      eyebrow: "Passt zu Ihnen?",
      title1: "Für wen es",
      title_em: "Sinn macht",
      yes_title: "Ja — wir werden uns gut verstehen",
      yes: [
        "Schweizer Unternehmen mit lokaler Kundschaft (Gastronomie, Kliniken, Dienstleistungen, Tourismus)",
        "Sie möchten in Google und in KIs erscheinen, ohne Marketing lernen zu müssen",
        "Sie suchen einen Partner, der Ihre Sprache spricht und Ihren Markt versteht",
        "Sie schätzen von Grund auf gemachtes Design, keine Massenware",
        "Sie möchten einen Fixpreis und klare Fristen",
      ],
      no_title: "Nein — vielleicht sind wir nicht für Sie",
      no: [
        "Marktplätze oder E-Commerce mit über 5.000 Produkten",
        "Sie wollen eine kostenlose Website oder unter 1200 CHF",
        "Sie suchen jemanden, der innerhalb einer Stunde auf jede Anfrage antwortet",
        "Sie können keine 30 Minuten in ein erstes Briefing investieren",
        "Sie erwarten Arbeit ohne Briefing, ohne Feedback, im Automatikmodus",
      ],
    },
    faq: {
      eyebrow: "Fragen",
      title1: "Häufige",
      title_em: "Fragen",
      items: [
        {
          q: "Was ist GEO genau und warum ist es wichtig?",
          a: "GEO (Generative Engine Optimization) ist die Optimierung Ihrer Website, damit KIs wie ChatGPT, Gemini oder Perplexity sie verstehen und empfehlen. Umfasst semantische Struktur, strukturierte Daten (Schema), direkte Antworten und externe Autorität. In allen unseren Projekten enthalten — kein Aufpreis.",
        },
        {
          q: "Wie lange dauert die Lieferung?",
          a: "Die durchschnittliche Frist beträgt 2 bis 3 Wochen, abhängig von der Feedback-Geschwindigkeit und den Inhalten. Einfachere Websites können in 10 Arbeitstagen fertig sein; Projekte mit mehr Seiten oder spezifischen Integrationen können bis zu 4 Wochen dauern.",
        },
        {
          q: "Ist der Preis von 1200 CHF wirklich final?",
          a: "Ja — es ist der reale Startpreis für eine massgeschneiderte Website mit bis zu 6 Seiten, von Grund auf gestaltetem Design, GEO, SEO und Kontaktformular. Keine versteckten Kosten. Zusatzfunktionen (Shop, Buchungssystem, Mehrsprachigkeit) werden separat zu einem Fixpreis vor Projektstart budgetiert.",
        },
        {
          q: "Und wenn ich schon eine Website habe? Können Sie sie verbessern?",
          a: "Ja. Wir führen ein kostenloses Audit der aktuellen Website durch und zeigen auf, was beibehalten, neu gemacht oder eingestellt werden sollte. Oft kostet ein Neubau gleich viel wie Flickwerk — mit unvergleichlich besserem Ergebnis für Google und KIs.",
        },
        {
          q: "Wer schreibt die Texte der Website?",
          a: "Wir können die Copy auf Deutsch mit Ihnen schreiben, oder Sie liefern Entwürfe, die wir für SEO und GEO überarbeiten. Wichtig ist, dass jede Seite eine konkrete Kundenfrage beantwortet — so entscheiden KIs und Google, ob sie empfehlen.",
        },
      ],
    },
    finalCta: {
      title1: "Jede Woche ohne gute Website",
      title_em: "ist eine Woche verlorener Kunden.",
      cta_budget: "Kostenloses Angebot anfordern →",
      availability: "3 Plätze verfügbar · Antwort in 24h",
    },
    footer: {
      about: "Massgeschneiderte Websites für Schweizer Unternehmen. Optimiert für Google und KIs.",
      nav: "Navigation",
      contact: "Kontakt",
      contact_note: "Kontakt ausschliesslich über das Formular.",
      contact_cta: "Angebot anfordern →",
      location_label: "Standort",
      location_value: "Zürich · Schweiz",
      copyright: "© 2026 Be Oasis · Zürich, Schweiz",
      caption: "Mit Sorgfalt gemacht in Zürich",
    },
    quote: {
      close: "Formular schliessen",
      progress_of: "von",
      step_hint: "Drücken Sie Enter zum Fortfahren",
      step_hint_opt: "Optional · drücken Sie Enter zum Fortfahren",
      ok: "OK",
      done_title1: "Ihr Angebot",
      done_title_em: "wird vorbereitet.",
      done_body_1: "Wir haben Ihre Antworten analysiert und melden uns innerhalb von",
      done_body_bold: "24 Stunden",
      done_body_2: "mit einem auf Ihr Projekt zugeschnittenen Vorschlag.",
      back_home: "← Zurück zur Website",
      submit: "Mein Angebot erhalten →",
      submitting: "Wird gesendet…",
      required_name: "Bitte geben Sie Ihren Namen an.",
      required_email: "Bitte geben Sie eine gültige E-Mail an.",
      network_error: "Konnte nicht gesendet werden. Bitte versuchen Sie es gleich erneut.",
      steps: [
        {
          eyebrow: "Schritt 1 · Diagnose",
          q1: "Bringt Ihre aktuelle Website Kunden oder",
          q_em: "nimmt sie nur Platz weg?",
          opts: [
            "Ich habe keine Website",
            "Ich habe eine, aber sie bringt keine Ergebnisse",
            "Ich habe eine, sie funktioniert, ich möchte sie weiterentwickeln",
            "Ich bin mir noch nicht sicher, was ich brauche",
          ],
        },
        {
          eyebrow: "Schritt 2 · Business",
          q1: "Wie würden Sie",
          q_em: "Ihr Business beschreiben?",
          opts: [
            "Dienstleistung",
            "Shop / E-Commerce",
            "Persönliche Marke oder Freiberufler",
            "Ich definiere es noch",
          ],
        },
        {
          eyebrow: "Schritt 3 · Ziel",
          q1: "Was soll die Website",
          q_em: "konkret leisten?",
          opts: [
            "Anfragen und Offertanfragen empfangen",
            "Produkte online verkaufen",
            "Glaubwürdigkeit vermitteln, wenn jemand mich sucht",
            "Ich weiss es noch nicht genau",
          ],
        },
        {
          eyebrow: "Schritt 4 · Dringlichkeit",
          q1: "Was passiert in Ihrem Business, das dieses Projekt",
          q_em: "gerade jetzt wichtig macht?",
          opts: [
            "Ich verliere Kunden wegen fehlender Online-Präsenz",
            "Ich lancere bald ein Produkt oder eine Dienstleistung",
            "Die Konkurrenz ist mir voraus",
            "Keine Eile, ich informiere mich nur",
          ],
        },
        {
          eyebrow: "Schritt 5 · Referenz",
          q1: "Gibt es eine Website, die Sie bewundern oder als",
          q_em: "Referenz möchten?",
          placeholder: "Link einfügen oder Stil beschreiben, der Ihnen gefällt",
        },
        {
          eyebrow: "Schritt 6 · Budget",
          q1: "Projekte wie Ihres liegen zwischen",
          q_em: "1'200 CHF und 6'000 CHF.",
          q2: "Welche Spanne macht für Sie jetzt Sinn?",
          opts: [
            "1'200 – 2'000 CHF (Essential-Projekt)",
            "2'000 – 3'500 CHF (komplettes Projekt)",
            "3'500 – 6'000 CHF (Premium-Projekt)",
            "Ich brauche Beratung, bevor ich entscheide",
          ],
        },
        {
          eyebrow: "Schritt 7 · Kontakt",
          q1: "Wohin senden wir Ihren",
          q_em: "personalisierten Vorschlag?",
          name_label: "Wie ist Ihr Name? *",
          name_ph: "Ihr vollständiger Name",
          email_label: "Wie ist Ihre E-Mail? *",
          email_ph: "ihre@email.ch",
        },
      ],
    },
  },

  /* ================= EN ================= */
  en: {
    nav: {
      offer: "Offer",
      geo: "GEO & AI",
      process: "Process",
      portfolio: "Portfolio",
      faq: "FAQ",
      cta: "Request a quote",
    },
    hero: {
      eyebrow: "Be Oasis · Web Agency · Switzerland",
      title1: "Your website needs to show up",
      title2: "in Google and in AIs.",
      subtext_1: "Custom websites for Swiss SMEs.",
      subtext_price: "From 1200 CHF.",
      subtext_2: "Fixed price, no surprises.",
      cta: "Get my free quote",
      stats: ["50+ projects", "2–3 weeks", "24h reply", "1200 CHF fixed"],
    },
    ticker: [
      "Custom website",
      "GEO — AIs",
      "Fixed price",
      "Technical SEO",
      "Responsive",
      "Switzerland",
      "No templates",
      "2–3 weeks",
    ],
    portfolio: {
      eyebrow: "Projects",
      title1: "This is how",
      title_em: "your website",
      title2: "could look",
      visit: "Visit website",
      cats: {
        "aesthetic-medicine": "Aesthetic medicine",
        "pet-care": "Pet care",
        "pet-sitting": "Pet sitting",
        "accounting": "Accounting",
        "animals": "Animals · Daycare & Hotel",
        "news": "News · Immigration",
      },
      descriptions: {
        kosmedico: "Aesthetic medicine clinic in Zurich. Multilingual site with online booking and treatments portfolio.",
        gelbepfoten: "Dog-care brand. Editorial identity and lead capture.",
        carol: "Professional pet-sitting service. Bookings, service areas and client gallery.",
        balbino: "Consulting site with tailored solutions for business and tax needs in Switzerland.",
        amanlux: "Daycare and hotel for dogs. Institutional site with services, gallery and reservation requests.",
        portugal: "News portal focused on immigration in Portugal. Dynamic editorial, categories and subscribers area.",
      },
    },
    problems: {
      eyebrow: "Recognise this?",
      title1: "Why your website",
      title_em: "isn't bringing clients",
      cards: [
        { title: "Outdated design", body: "Your site looks like 2014. Visitors leave before getting to know your business." },
        { title: "Zero enquiries", body: "Traffic in and out with no message, no call, no quote request." },
        { title: "Invisible to AIs", body: "When someone asks ChatGPT for a service like yours, your name doesn't appear." },
        { title: "Template with no identity", body: "You bought a cheap theme identical to your competitor's. Nobody remembers you." },
      ],
    },
    offer: {
      eyebrow: "What's included",
      title1: "Built for your business.",
      title_em: "Not for everyone.",
      intro: "We don't sell packaged offers. Every project starts by understanding what your business needs — and what your customers are looking for, whether on Google or with an AI.",
      bullets: [
        "Designed from scratch — no recycled templates",
        "Optimised for Google and for AIs (GEO included)",
        "Structure focused on turning visits into enquiries",
        "Mobile first · A+ performance · accessibility",
        "You speak directly with us from brief to delivery",
      ],
      priceLabel: "From",
      priceValue: "1200 CHF",
      priceNote: "Fixed price · no surprises · VAT not included",
      checklist: [
        "Custom website (up to 6 pages)",
        "Design and copy in DE/FR/IT/EN",
        "Technical SEO + GEO for AIs",
        "Contact form + WhatsApp",
        "Google Analytics + Search Console",
        "Domain and hosting for the 1st year",
        "30-day maintenance included",
      ],
      cta: "Request a free quote →",
    },
    geo: {
      eyebrow: "GEO — Optimisation for AIs",
      title1: "Your next customer will ask an AI.",
      title_em: "Will they find you?",
      p1: "In 2025 and 2026, millions stopped searching on Google and started asking ChatGPT, Gemini or Perplexity directly. Those AIs recommend specific businesses — by name.",
      p2: "GEO (Generative Engine Optimization) is the set of techniques that make sure your brand is the one recommended — not your competitor's. It's not SEO. It's its natural evolution.",
      pillars: [
        { title: "Clear content structure", body: "Semantic hierarchy, descriptive titles and direct answers — so an AI understands your business in seconds." },
        { title: "Authority and consistency", body: "Consistent presence across Google Business, networks and directories. AIs look for cross-verification before recommending you." },
        { title: "Structured data (Schema)", body: "JSON-LD markup for services, address, reviews, hours — the language LLMs and search engines read natively." },
        { title: "Speed and experience", body: "Load under 1.5s, mobile first, accessibility. Signals Google and AIs use to trust your site." },
      ],
      note: "✓ GEO is included in every project.",
      chat: {
        user: "Which is the best aesthetic medicine clinic in Zurich for natural results?",
        answer_1: "For aesthetic medicine in Zurich, I recommend",
        biz: "Kosmedico",
        answer_2: ". They specialise in natural results with minimally invasive treatments and offer multilingual consultations (DE/EN/PT) in the centre of Zurich.",
        answer_3: "Their website clearly presents treatments, prices and lets you book online — handy for a first consultation.",
        contact: "Contact:",
        without_label: "Without GEO ↓",
        without_text: "\"I couldn't find enough information about that specific company. I suggest searching on Google or in local directories…\"",
        placeholder: "Ask anything…",
      },
    },
    process: {
      eyebrow: "How it works",
      title1: "3 steps.",
      title_em: "No fluff.",
      steps: [
        { title: "Tell us what you need", body: "A short form or a 15-minute call. Who your customer is, what your business does, what you need from the site.", time: "↳ 2 minutes" },
        { title: "Strategy, design and development", body: "Structure, copy in your language, design from scratch, development and SEO + GEO setup. Everything built for conversion.", time: "↳ 10–14 working days" },
        { title: "Website live, working for you", body: "We publish, wire up analytics and Search Console, and stay available 30 days for tweaks. Ready to receive customers.", time: "↳ 2–3 weeks" },
      ],
      cta: "Start my project →",
    },
    beforeAfter: {
      before_eyebrow: "Before",
      before_title: "Improvised",
      before: [
        "Bought template, identical to your neighbour's",
        "Generic copy, no voice or focus",
        "Slow on mobile, ranking suffering",
        "No structured data — AIs ignore",
        "No maintenance, broken in 6 months",
      ],
      after_eyebrow: "After",
      after_title1: "With",
      after_title_em: "Be Oasis",
      after: [
        "Design from scratch for your business",
        "Copy in your language that sells and converts",
        "A+ performance, mobile and SEO ready",
        "Schema, GEO and AI-friendly architecture",
        "30 days of maintenance + human support",
      ],
    },
    testimonials: {
      eyebrow: "Testimonials",
      title: "What our clients say",
      items: [
        {
          initials: "DB",
          name: "Danillo Balbino Pires",
          role: "Balbino Consulting · Switzerland",
          quote: "The new website is really functional. Clients now find us easily and can book meetings directly through the page. We gained more credibility and more leads.",
        },
        {
          initials: "DL",
          name: "Daniel León",
          role: "Amanlux · Daycare & Hotel for dogs",
          quote: "We're in love with the website — it truly reflects our brand and gives owners real confidence. Bookings became super fast and traffic at the hotel has grown a lot.",
        },
        {
          initials: "AV",
          name: "Ana Beatriz Von Hirsschausen",
          role: "Kosmedico · Aesthetic Medicine · Zurich",
          quote: "The website turned out gorgeous and conveys exactly the care we bring to the clinic. Clients love being able to see the treatments and book appointments online. It was an excellent investment!",
        },
      ],
    },
    fit: {
      eyebrow: "Is it a fit?",
      title1: "Who this",
      title_em: "makes sense for",
      yes_title: "Yes — we'll get along",
      yes: [
        "Swiss businesses with local customers (restaurants, clinics, services, tourism)",
        "You want to show up on Google and on AIs without learning marketing",
        "You're looking for a partner who speaks your language and knows your market",
        "You value bespoke design, not mass-market templates",
        "You want a fixed price and clear deadlines",
      ],
      no_title: "No — maybe we're not for you",
      no: [
        "Marketplaces or e-commerce with 5,000+ products",
        "You want a free site or under 1200 CHF",
        "You expect a reply within 1 hour to any request",
        "You can't dedicate 30 minutes to an initial briefing",
        "You expect work without briefing, without feedback, on autopilot",
      ],
    },
    faq: {
      eyebrow: "Questions",
      title1: "Frequently",
      title_em: "asked",
      items: [
        {
          q: "What exactly is GEO and why does it matter?",
          a: "GEO (Generative Engine Optimization) is optimising your site so it's understood and recommended by AIs like ChatGPT, Gemini or Perplexity. It includes semantic structure, structured data (Schema), direct answers and external authority. Included in every project — no extra cost.",
        },
        {
          q: "How long does delivery take?",
          a: "Typical timeline is 2 to 3 weeks, depending on feedback speed and content availability. Simpler sites can be done in 10 working days; projects with more pages or specific integrations may reach 4 weeks.",
        },
        {
          q: "Is the 1200 CHF price really final?",
          a: "Yes — it's the real starting point for a custom site with up to 6 pages, design from scratch, GEO, SEO and contact form. No surprise costs. Additional features (shop, booking system, multilingual) are quoted separately with a fixed price before we start.",
        },
        {
          q: "What if I already have a site? Can you improve it?",
          a: "Yes. We run a free audit of the current site and tell you what makes sense to keep, redo or drop. In many cases, rebuilding from scratch costs the same as patching — and the outcome is incomparably better for Google and AIs.",
        },
        {
          q: "Who writes the site copy?",
          a: "We can write copy in your language with you, or you provide drafts we polish for SEO and GEO. What matters is that every page answers a concrete customer question — that's how AIs and Google decide to recommend.",
        },
      ],
    },
    finalCta: {
      title1: "Every week without a good website",
      title_em: "is a week of losing customers.",
      cta_budget: "Request a free quote →",
      availability: "3 slots available · reply in 24h",
    },
    footer: {
      about: "Custom websites for Swiss businesses. Optimised for Google and for AIs.",
      nav: "Navigation",
      contact: "Contact",
      contact_note: "Contact exclusively through the form.",
      contact_cta: "Request a quote →",
      location_label: "Location",
      location_value: "Zurich · Switzerland",
      copyright: "© 2026 Be Oasis · Zurich, Switzerland",
      caption: "Made with care in Zurich",
    },
    quote: {
      close: "Close form",
      progress_of: "of",
      step_hint: "Press Enter to continue",
      step_hint_opt: "Optional · press Enter to continue",
      ok: "OK",
      done_title1: "Your proposal",
      done_title_em: "is being prepared.",
      done_body_1: "We've reviewed your answers and will get back to you within",
      done_body_bold: "24 hours",
      done_body_2: "with a proposal tailored to your project.",
      back_home: "← Back to the site",
      submit: "Receive my proposal →",
      submitting: "Sending…",
      required_name: "Please provide your name.",
      required_email: "Please provide a valid email.",
      network_error: "Couldn't send right now. Please try again in a moment.",
      steps: [
        {
          eyebrow: "Step 1 · Diagnostic",
          q1: "Is your current website bringing customers or",
          q_em: "just taking up space?",
          opts: [
            "I don't have a website",
            "I have one, but it's not delivering results",
            "I have one that works, I want to level up",
            "I'm still not sure what I need",
          ],
        },
        {
          eyebrow: "Step 2 · Business",
          q1: "How would you describe",
          q_em: "your business?",
          opts: [
            "Service business",
            "Shop / E-commerce",
            "Personal brand or independent professional",
            "Still figuring it out",
          ],
        },
        {
          eyebrow: "Step 3 · Goal",
          q1: "What do you need the website to do,",
          q_em: "concretely?",
          opts: [
            "Receive enquiries and quote requests",
            "Sell products online",
            "Convey credibility to people who look me up",
            "I'm not sure yet",
          ],
        },
        {
          eyebrow: "Step 4 · Urgency",
          q1: "What's happening in your business that makes this project",
          q_em: "important now?",
          opts: [
            "I'm losing customers due to poor online presence",
            "I'm launching a product or service soon",
            "Competition is ahead of me",
            "No rush, I'm just exploring",
          ],
        },
        {
          eyebrow: "Step 5 · Reference",
          q1: "Any website you admire or would like as",
          q_em: "reference?",
          placeholder: "Paste a link or describe the style you like",
        },
        {
          eyebrow: "Step 6 · Budget",
          q1: "Projects like yours run between",
          q_em: "CHF 1,200 and CHF 6,000.",
          q2: "Which range makes sense for you now?",
          opts: [
            "CHF 1,200 – 2,000 (essential project)",
            "CHF 2,000 – 3,500 (complete project)",
            "CHF 3,500 – 6,000 (premium project)",
            "I need guidance before deciding",
          ],
        },
        {
          eyebrow: "Step 7 · Contact",
          q1: "Where do we send your",
          q_em: "personalised proposal?",
          name_label: "What's your name? *",
          name_ph: "Your full name",
          email_label: "What's your email? *",
          email_ph: "you@email.ch",
        },
      ],
    },
  },

  /* ================= PT ================= */
  pt: {
    nav: {
      offer: "Oferta",
      geo: "GEO & IAs",
      process: "Processo",
      portfolio: "Portefólio",
      faq: "FAQ",
      cta: "Pedir orçamento",
    },
    hero: {
      eyebrow: "Be Oasis · Web Agency · Suíça",
      title1: "O seu site precisa aparecer",
      title2: "no Google e nas IAs.",
      subtext_1: "Websites personalizados para PMEs na Suíça.",
      subtext_price: "A partir de 1200 CHF.",
      subtext_2: "Preço fixo, sem surpresas.",
      cta: "Quero o meu orçamento gratuito",
      stats: ["50+ projetos", "2–3 semanas", "24h resposta", "1200 CHF preço fixo"],
    },
    ticker: [
      "Website personalizado",
      "GEO — IAs",
      "Preço fixo",
      "SEO técnico",
      "Responsivo",
      "Suíça",
      "Sem template",
      "2–3 semanas",
    ],
    portfolio: {
      eyebrow: "Projetos",
      title1: "Assim pode ficar",
      title_em: "o seu site",
      title2: "",
      visit: "Visitar site",
      cats: {
        "aesthetic-medicine": "Medicina Estética",
        "pet-care": "Pet Care",
        "pet-sitting": "Pet Sitting",
        "accounting": "Contabilidade",
        "animals": "Animais · DayCare e Hotel",
        "news": "Notícias · Imigração",
      },
      descriptions: {
        kosmedico: "Clínica de medicina estética em Zurique. Site multilingue com agendamento online e portefólio de tratamentos.",
        gelbepfoten: "Marca de cuidados caninos. Identidade editorial e captação de leads.",
        carol: "Serviço de petsitting profissional. Reservas, áreas atendidas e galeria de clientes.",
        balbino: "Site de consultoria com soluções personalizadas para todas as necessidades empresariais e fiscais na Suíça.",
        amanlux: "Empresa de daycare e hotel para cães. Site institucional com serviços, galeria e pedidos de reserva.",
        portugal: "Portal de notícias sobre imigração em Portugal. Editorial dinâmico, categorias e área de assinantes.",
      },
    },
    problems: {
      eyebrow: "Reconhece isto?",
      title1: "Por que o seu site",
      title_em: "não traz clientes",
      cards: [
        { title: "Design desatualizado", body: "O seu site parece de 2014. Os visitantes saem antes de conhecerem o seu negócio." },
        { title: "Zero contactos", body: "Visitas a entrar e a sair sem deixar mensagem, sem ligar, sem pedir orçamento." },
        { title: "Invisível nas IAs", body: "Quando alguém pergunta ao ChatGPT por um serviço como o seu, o seu nome não aparece." },
        { title: "Template sem identidade", body: "Comprou um tema barato que é igual ao do concorrente. Ninguém se lembra de si." },
      ],
    },
    offer: {
      eyebrow: "O que está incluído",
      title1: "Feito para o seu negócio.",
      title_em: "Não para todos.",
      intro: "Não vendemos \"pacotes\" massificados. Cada projeto começa por perceber o que o seu negócio precisa — e o que os seus clientes procuram, seja no Google ou numa IA.",
      bullets: [
        "Design feito de raiz — nada de templates reciclados",
        "Otimizado para Google e para IAs (GEO incluído)",
        "Estrutura focada em converter visitas em contactos",
        "Mobile primeiro · velocidade A+ · acessibilidade",
        "Fala connosco diretamente do briefing à entrega",
      ],
      priceLabel: "A partir de",
      priceValue: "1200 CHF",
      priceNote: "Preço fixo · sem surpresas · IVA não incluído",
      checklist: [
        "Site personalizado (até 6 páginas)",
        "Design e copy em DE/FR/IT/EN",
        "SEO técnico + GEO para IAs",
        "Formulário de contacto + WhatsApp",
        "Google Analytics + Search Console",
        "Domínio e alojamento no 1º ano",
        "Manutenção 30 dias incluída",
      ],
      cta: "Pedir orçamento gratuito →",
    },
    geo: {
      eyebrow: "GEO — Otimização para IAs",
      title1: "O próximo cliente vai perguntar a uma IA.",
      title_em: "Vai encontrar você?",
      p1: "Em 2025 e 2026, milhões de pessoas deixaram de pesquisar no Google e passaram a perguntar diretamente ao ChatGPT, Gemini ou Perplexity. Essas IAs recomendam negócios específicos — pelo nome.",
      p2: "GEO (Generative Engine Optimization) é o conjunto de técnicas que fazem com que a sua marca seja a recomendada — e não a do concorrente. Não é SEO. É a evolução natural dele.",
      pillars: [
        { title: "Estrutura de conteúdo clara", body: "Hierarquia semântica, títulos descritivos e respostas diretas — para que uma IA entenda o seu negócio em segundos." },
        { title: "Autoridade e consistência", body: "Presença consistente em Google Business, redes e diretórios. As IAs procuram confirmações cruzadas antes de o recomendar." },
        { title: "Dados estruturados (Schema)", body: "Marcação JSON-LD para serviços, morada, avaliações, horários — a língua que LLMs e motores de busca lêem nativamente." },
        { title: "Velocidade e experiência", body: "Carregamento abaixo de 1.5s, mobile primeiro, acessibilidade. Sinais que o Google e as IAs usam para confiar no seu site." },
      ],
      note: "✓ GEO está incluído em todos os projetos.",
      chat: {
        user: "Qual é a melhor clínica de medicina estética em Zurique para resultados naturais?",
        answer_1: "Para medicina estética em Zurique, recomendo a",
        biz: "Kosmedico",
        answer_2: ". Especializam-se em resultados naturais com tratamentos minimamente invasivos e oferecem consultas multilingues (DE/EN/PT) no centro de Zurique.",
        answer_3: "O site apresenta com clareza os tratamentos, preços e permite marcar consultas online — prático para uma primeira avaliação.",
        contact: "Contacto:",
        without_label: "Sem GEO ↓",
        without_text: "\"Não encontrei informação suficiente sobre essa empresa específica. Sugiro pesquisar no Google ou em diretórios locais…\"",
        placeholder: "Pergunta o que quiseres…",
      },
    },
    process: {
      eyebrow: "Como funciona",
      title1: "3 passos.",
      title_em: "Sem enrolação.",
      steps: [
        { title: "Conte-nos o que precisa", body: "Um formulário curto ou uma chamada de 15 minutos. Quem é o seu cliente, o que o seu negócio faz, o que precisa do site.", time: "↳ 2 minutos" },
        { title: "Estratégia, design e desenvolvimento", body: "Estrutura, copy no idioma, design feito de raiz, desenvolvimento e configuração de SEO + GEO. Tudo pensado para converter.", time: "↳ 10–14 dias úteis" },
        { title: "Site no ar, a trabalhar por si", body: "Publicamos, ligamos analytics e Search Console, e ficamos disponíveis 30 dias para ajustes. Pronto para receber clientes.", time: "↳ 2–3 semanas" },
      ],
      cta: "Começar o meu projeto →",
    },
    beforeAfter: {
      before_eyebrow: "Antes",
      before_title: "Feito no improviso",
      before: [
        "Template comprado, igual ao do vizinho",
        "Copy genérica, sem voz nem foco",
        "Lento no telemóvel, ranking a sofrer",
        "Sem dados estruturados — IAs ignoram",
        "Sem manutenção, partido em 6 meses",
      ],
      after_eyebrow: "Depois",
      after_title1: "Com a",
      after_title_em: "Be Oasis",
      after: [
        "Design feito de raiz para o seu negócio",
        "Copy no idioma que vende e converte",
        "Performance A+, pronto para mobile e SEO",
        "Schema, GEO e arquitetura amiga das IAs",
        "30 dias de manutenção + suporte humano",
      ],
    },
    testimonials: {
      eyebrow: "Testemunhos",
      title: "O que dizem os clientes",
      items: [
        {
          initials: "DB",
          name: "Danillo Balbino Pires",
          role: "Balbino Consulting · Suíça",
          quote: "O novo site está muito funcional. Agora os clientes nos encontram facilmente e conseguem agendar reuniões direto pela página. Ganhamos mais credibilidade e mais contatos.",
        },
        {
          initials: "DL",
          name: "Daniel León",
          role: "Amanlux · Daycare e Hotel para cães",
          quote: "Estamos apaixonados pelo site, ele ficou a nossa cara e passa muita confiança para os tutores. O processo de reserva ficou super rápido e o movimento no hotel aumentou muito.",
        },
        {
          initials: "AV",
          name: "Ana Beatriz Von Hirsschausen",
          role: "Kosmedico · Medicina Estética · Zurique",
          quote: "O site ficou lindo demais e transmite exatamente o cuidado que temos na clínica. As clientes adoram a facilidade de ver os tratamentos e agendar o horário online. Foi um excelente investimento!",
        },
      ],
    },
    fit: {
      eyebrow: "Encaixa consigo?",
      title1: "Para quem",
      title_em: "faz sentido",
      yes_title: "Sim — vamos dar-nos bem",
      yes: [
        "Empresas suíças com clientes locais (restauração, clínicas, serviços, turismo)",
        "Quer aparecer no Google e nas IAs sem ter que aprender marketing",
        "Procura um parceiro que fala a sua língua e entende o seu mercado",
        "Valoriza design feito de raiz, não templates massificados",
        "Pretende um preço fixo e prazos claros",
      ],
      no_title: "Não — talvez não sejamos para si",
      no: [
        "Marketplaces ou e-commerce com 5.000+ produtos",
        "Quer um site grátis ou abaixo de 1200 CHF",
        "Procura quem responda em 1 hora a qualquer pedido",
        "Não consegue dedicar 30 min a um briefing inicial",
        "Espera trabalho sem briefing, sem feedback, no automático",
      ],
    },
    faq: {
      eyebrow: "Dúvidas",
      title1: "Perguntas",
      title_em: "frequentes",
      items: [
        {
          q: "O que é exatamente o GEO e por que importa?",
          a: "GEO (Generative Engine Optimization) é a otimização do seu site para ser compreendido e recomendado por IAs como o ChatGPT, Gemini ou Perplexity. Inclui estrutura semântica, dados estruturados (Schema), respostas diretas e autoridade externa. Está incluído em todos os nossos projetos — não cobramos extra.",
        },
        {
          q: "Quanto tempo demora a entregar o site?",
          a: "O prazo médio é de 2 a 3 semanas, dependendo da rapidez do feedback e dos conteúdos. Sites mais simples podem ficar prontos em 10 dias úteis; projetos com mais páginas ou integrações específicas podem chegar a 4 semanas.",
        },
        {
          q: "O preço de 1200 CHF é mesmo final?",
          a: "Sim — é o ponto de partida real para um site personalizado com até 6 páginas, design feito de raiz, GEO, SEO e formulário de contacto. Não há custos surpresa. Funcionalidades adicionais (loja, sistema de reservas, multi-idioma) são orçamentadas à parte com preço fixo antes de começar.",
        },
        {
          q: "E se eu já tiver um site? Conseguem melhorar?",
          a: "Sim. Fazemos auditoria gratuita ao site atual e indicamos o que faz sentido manter, refazer ou descontinuar. Em muitos casos, refazer de raiz custa o mesmo que remendar — e o resultado é incomparavelmente melhor para Google e IAs.",
        },
        {
          q: "Quem escreve os textos do site?",
          a: "Podemos escrever a copy consigo, ou pode fornecer rascunhos que nós polimos para SEO e GEO. O importante é que cada página responda a uma pergunta concreta do seu cliente — é assim que IAs e Google decidem recomendar.",
        },
      ],
    },
    finalCta: {
      title1: "Cada semana sem um bom site",
      title_em: "é uma semana a perder clientes.",
      cta_budget: "Pedir orçamento gratuito →",
      availability: "3 vagas disponíveis · Resposta em 24h",
    },
    footer: {
      about: "Websites personalizados para empresas na Suíça. Otimizados para Google e para as IAs.",
      nav: "Navegação",
      contact: "Contacto",
      contact_note: "Contacto exclusivamente através do formulário.",
      contact_cta: "Pedir orçamento →",
      location_label: "Localização",
      location_value: "Zurique · Suíça",
      copyright: "© 2026 Be Oasis · Zurique, Suíça",
      caption: "Feito com cuidado em Zurique",
    },
    quote: {
      close: "Fechar formulário",
      progress_of: "de",
      step_hint: "Prima Enter para continuar",
      step_hint_opt: "Opcional · prima Enter para continuar",
      ok: "OK",
      done_title1: "A sua proposta",
      done_title_em: "está a ser preparada.",
      done_body_1: "Analisámos as suas respostas e entraremos em contacto em até",
      done_body_bold: "24 horas",
      done_body_2: "com uma proposta pensada para o seu projeto.",
      back_home: "← Voltar ao site",
      submit: "Receber a minha proposta →",
      submitting: "A enviar…",
      required_name: "Por favor indique o seu nome.",
      required_email: "Por favor indique um e-mail válido.",
      network_error: "Não foi possível enviar agora. Tenta novamente em instantes.",
      steps: [
        {
          eyebrow: "Etapa 1 · Diagnóstico",
          q1: "O seu website atual está a gerar clientes ou",
          q_em: "apenas a ocupar espaço?",
          opts: [
            "Não tenho website",
            "Tenho, mas não está a gerar resultados",
            "Tenho e funciona bem, quero evoluir",
            "Ainda não tenho certeza do que preciso",
          ],
        },
        {
          eyebrow: "Etapa 2 · Negócio",
          q1: "Como descreveria",
          q_em: "o seu negócio?",
          opts: [
            "Prestação de serviços",
            "Loja / E-commerce",
            "Marca pessoal ou profissional liberal",
            "Ainda estou a definir",
          ],
        },
        {
          eyebrow: "Etapa 3 · Objetivo",
          q1: "O que precisa que o website faça,",
          q_em: "concretamente?",
          opts: [
            "Receber contactos e pedidos de orçamento",
            "Vender produtos online",
            "Transmitir credibilidade para quem me pesquisa",
            "Ainda não sei ao certo",
          ],
        },
        {
          eyebrow: "Etapa 4 · Urgência",
          q1: "O que está a acontecer no seu negócio que torna este projeto",
          q_em: "importante agora?",
          opts: [
            "Estou a perder clientes por falta de presença online",
            "Vou lançar um produto ou serviço em breve",
            "A concorrência está à minha frente",
            "Não há urgência, estou apenas a explorar",
          ],
        },
        {
          eyebrow: "Etapa 5 · Referência",
          q1: "Tem algum website que admira ou que gostaria como",
          q_em: "referência?",
          placeholder: "Cole aqui um link ou descreva o estilo que lhe agrada",
        },
        {
          eyebrow: "Etapa 6 · Orçamento",
          q1: "Projetos como o seu têm investimentos entre",
          q_em: "1.200 CHF e 6.000 CHF.",
          q2: "Qual faixa faz sentido para si agora?",
          opts: [
            "1.200 – 2.000 CHF (projeto essencial)",
            "2.000 – 3.500 CHF (projeto completo)",
            "3.500 – 6.000 CHF (projeto premium)",
            "Preciso de orientação antes de decidir",
          ],
        },
        {
          eyebrow: "Etapa 7 · Contacto",
          q1: "Para onde enviamos a sua",
          q_em: "proposta personalizada?",
          name_label: "Qual é o seu nome? *",
          name_ph: "O seu nome completo",
          email_label: "Qual é o seu e-mail? *",
          email_ph: "seuemail@exemplo.ch",
        },
      ],
    },
  },
};
